import { useState } from "react";
import {
  Search,
  Filter,
  ChevronDown,
  Check,
  Star,
  Package,
} from "lucide-react";

export function ProductsFilters({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  categoryFilter,
  setCategoryFilter,
  popularFilter,
  setPopularFilter,
  sortBy,
  setSortBy,
  categories,
}) {
  const [filterOpen, setFilterOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);

  return (
    <div className="bg-white dark:bg-[#1E1E1E] border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl p-4">
      <div className="flex flex-col gap-3">
        {/* Search */}
        <div className="relative flex-1">
          <Search
            size={18}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#666666] dark:text-[#A0A0A0]"
          />
          <input
            type="text"
            placeholder="Search products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-[#E5E7EB] dark:border-[#2A2A2A] bg-[#F9FAFB] dark:bg-[#262626] text-[#111111] dark:text-white placeholder-[#666666] dark:placeholder-[#A0A0A0] focus:outline-none focus:ring-2 focus:ring-[#62397f] dark:focus:ring-[#7C3AED] transition-all text-sm font-inter"
          />
        </div>

        {/* Filter Row */}
        <div className="flex flex-wrap gap-3">
          {/* Status Filter */}
          <div className="relative">
            <button
              onClick={() => {
                setFilterOpen(!filterOpen);
                setSortOpen(false);
                setCategoryDropdownOpen(false);
              }}
              className="flex items-center gap-2 px-4 py-2.5 border border-[#E5E7EB] dark:border-[#2A2A2A] bg-white dark:bg-[#262626] text-[#111111] dark:text-white rounded-lg font-medium text-sm font-inter transition-all hover:bg-[#F9FAFB] dark:hover:bg-[#1E1E1E]"
            >
              <Filter size={18} />
              <span className="hidden sm:inline">Status</span>
              <ChevronDown size={16} />
            </button>
            {filterOpen && (
              <div className="absolute left-0 mt-2 w-48 bg-white dark:bg-[#1A1A1A] border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl shadow-lg overflow-hidden z-20">
                {[
                  { value: "all", label: "All" },
                  { value: "active", label: "Active" },
                  { value: "disabled", label: "Disabled" },
                  // { value: "low-stock", label: "Low Stock" },
                  // { value: "out-of-stock", label: "Out of Stock" },
                ].map((status) => (
                  <button
                    key={status.value}
                    onClick={() => {
                      setStatusFilter(status.value);
                      setFilterOpen(false);
                    }}
                    className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-[#111111] dark:text-white hover:bg-[#F9FAFB] dark:hover:bg-[#262626] transition-colors font-inter"
                  >
                    <span>{status.label}</span>
                    {statusFilter === status.value && (
                      <Check size={16} className="text-[#62397f]" />
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Category Filter */}
          <div className="relative">
            <button
              onClick={() => {
                setCategoryDropdownOpen(!categoryDropdownOpen);
                setFilterOpen(false);
                setSortOpen(false);
              }}
              className={`flex items-center gap-2 px-4 py-2.5 border rounded-lg font-medium text-sm font-inter transition-all ${categoryFilter !== "all"
                ? "bg-[#F5F3FF] dark:bg-[#2A2440] border-[#62397f] dark:border-[#7C3AED] text-[#62397f] dark:text-[#A78BFA]"
                : "border-[#E5E7EB] dark:border-[#2A2A2A] bg-white dark:bg-[#262626] text-[#111111] dark:text-white hover:bg-[#F9FAFB] dark:hover:bg-[#1E1E1E]"
                }`}
            >
              <Package size={18} />
              <span className="hidden sm:inline">
                {categoryFilter === "all"
                  ? "Category"
                  : categories.find((c) => c.id.toString() === categoryFilter)?.name || "Category"}
              </span>
              <ChevronDown size={16} />
            </button>
            {categoryDropdownOpen && (
              <div className="absolute left-0 mt-2 w-48 bg-white dark:bg-[#1A1A1A] border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl shadow-lg overflow-hidden z-20">
                <button
                  onClick={() => {
                    setCategoryFilter("all");
                    setCategoryDropdownOpen(false);
                  }}
                  className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-[#111111] dark:text-white hover:bg-[#F9FAFB] dark:hover:bg-[#262626] transition-colors font-inter"
                >
                  <span>All Categories</span>
                  {categoryFilter === "all" && (
                    <Check size={16} className="text-[#62397f]" />
                  )}
                </button>
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => {
                      setCategoryFilter(cat.id.toString());
                      setCategoryDropdownOpen(false);
                    }}
                    className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-[#111111] dark:text-white hover:bg-[#F9FAFB] dark:hover:bg-[#262626] transition-colors font-inter"
                  >
                    <span>{cat.name}</span>
                    {categoryFilter === cat.id.toString() && (
                      <Check size={16} className="text-[#62397f]" />
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Popular Toggle */}
          <button
            onClick={() => setPopularFilter(!popularFilter)}
            className={`flex items-center gap-2 px-4 py-2.5 border rounded-lg font-medium text-sm font-inter transition-all ${popularFilter
              ? "bg-[#F5F3FF] dark:bg-[#2A2440] border-[#62397f] dark:border-[#7C3AED] text-[#62397f] dark:text-[#A78BFA]"
              : "border-[#E5E7EB] dark:border-[#2A2A2A] bg-white dark:bg-[#262626] text-[#111111] dark:text-white hover:bg-[#F9FAFB] dark:hover:bg-[#1E1E1E]"
              }`}
          >
            <Star size={18} fill={popularFilter ? "currentColor" : "none"} />
            <span className="hidden sm:inline">Popular</span>
          </button>

          {/* Sort */}
          <div className="relative ml-auto">
            <button
              onClick={() => {
                setSortOpen(!sortOpen);
                setFilterOpen(false);
                setCategoryDropdownOpen(false);
              }}
              className="flex items-center gap-2 px-4 py-2.5 border border-[#E5E7EB] dark:border-[#2A2A2A] bg-white dark:bg-[#262626] text-[#111111] dark:text-white rounded-lg font-medium text-sm font-inter transition-all hover:bg-[#F9FAFB] dark:hover:bg-[#1E1E1E]"
            >
              Sort
              <ChevronDown size={16} />
            </button>
            {sortOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-[#1A1A1A] border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl shadow-lg overflow-hidden z-20">
                {[
                  { value: "name", label: "Name" },
                  { value: "date", label: "Date Created" },
                  { value: "price", label: "Price" },
                  { value: "quantity", label: "Quantity" },
                ].map((option) => (
                  <button
                    key={option.value}
                    onClick={() => {
                      setSortBy(option.value);
                      setSortOpen(false);
                    }}
                    className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-[#111111] dark:text-white hover:bg-[#F9FAFB] dark:hover:bg-[#262626] transition-colors font-inter"
                  >
                    <span>{option.label}</span>
                    {sortBy === option.value && (
                      <Check size={16} className="text-[#62397f]" />
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
